<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.services')" />
            </template>
        </PageHeader>
        <Services />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import Services from '../Common/Services'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'ServicesPage',
    components: {
        PageHeader,
        Navbar,
        PageTitle,
        Services,
        Footer,
        FreeTrial
    }
}
</script>
